import { FC } from 'react';

import { ModalProps, Row } from 'antd';
import { useAppSelector } from 'hooks/redux';
import { getText } from 'utils/stringUtil';
import {
  ITS_QUIET_IN_HERE,
  PAGE_NO_LONGER_AVAILABLE,
  CONTACT_SYSTEM_ADMINISTRATOR,
} from 'constants/languageConstants';
import notebookIcon from 'images/icons/notebook.svg';

import styles from './errorBoundary.module.less';

interface Props extends ModalProps {
  lineOne?: string;
  lineTwo?: string;
}

const ErrorBoundary: FC<Props> = (props: Props) => {
  const { lineOne = '', lineTwo = '' } = props;
  const language = useAppSelector((state) => state.benguide.data?.language);

  return (
    <div
      className={`${styles.errorBoundaryWrapper} ${
        lineOne ? `${styles.noLeftMargin}` : ''
      }`}
    >
      <Row className={styles.detailsWrapper}>
        <img src={notebookIcon} alt="edit" />
      </Row>
      <Row className={styles.header}>
        {getText(ITS_QUIET_IN_HERE, language)}
      </Row>
      <Row className={styles.subHeader}>
        <span className={styles.firstLine}>
          {lineOne ? lineOne : getText(PAGE_NO_LONGER_AVAILABLE, language)}
        </span>
        <br />
        <span>
          {lineTwo ? lineTwo : getText(CONTACT_SYSTEM_ADMINISTRATOR, language)}
        </span>
      </Row>
    </div>
  );
};

export default ErrorBoundary;
